"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "./contexts/AuthContext";
import Hero from "./components/landing/Hero";
import PillarTrio from "./components/landing/PillarTrio";
import SegmentRow from "./components/landing/SegmentRow";
import FounderColumn from "./components/landing/FounderColumn";
import PricingStrip from "./components/landing/PricingStrip";
import ComingSoonSection from "./components/landing/ComingSoonSection";
import FinalCta from "./components/landing/FinalCta";
import Faq from "./components/Faq";
import { FAQ_TRUST } from "../lib/faqData";

// Landing page (joinmaren.com). One conversion goal: every CTA pathway
// resolves to /signup ("Start Free"). The secondary CTA on the hero is
// a smooth-scroll to the workflow section today; it will swap to a
// VideoModal opener when the walkthrough video ships.
//
// Above-the-fold on 1440x900 desktop is the entire pitch: headline,
// subhead, both CTAs, founder credibility line, dashboard preview, and
// the proof row. The remaining sections support trust, audience fit,
// pricing, and objection handling.
export default function LandingPage() {
  const { session, loading } = useAuth();
  const router = useRouter();

  // Signed-in visitors are bounced to /dashboard. We still render the
  // landing markup so search crawlers and first-paint show real content
  // rather than a spinner, and the redirect runs as soon as auth
  // resolves.
  useEffect(() => {
    if (!loading && session) router.replace("/dashboard");
  }, [session, loading, router]);

  return (
    <main className="flex-1">
      <Hero />
      {/* Founder vouches before the mechanics: Isaiah's story sits
          directly under the hero, then the how-it-works pillars. The
          product demo lives in the hero's "Watch the demo" modal (the
          two first actions on the site: sign up, or watch the demo). */}
      <FounderColumn />
      <PillarTrio />
      <SegmentRow />
      <PricingStrip />
      <Faq
        items={FAQ_TRUST}
        eyebrow="FAQ"
        heading="Questions before you start"
        intro="The objections we hear most often. Full pricing and plan questions live on the pricing page."
        id="faq"
      />
      <ComingSoonSection />
      <FinalCta />
    </main>
  );
}
